/* Pulse finder capture (Andre, 2026-09-13: "can we see if someone selects Nike size 9?", then
   "add to Google Analytics ... and do the same thing with the Find My Style answers").

   Two kinds of answer, three destinations each, all sent from the shopper's own browser:

     kind    Klaviyo event          cart attribute   GA4 event
     size    Used Size Finder       Size finder      size_finder_used
     style   Used Style Finder      Style finder     style_finder_result

   1. Klaviyo: the event lands on the profile klaviyo.js already recognises in this browser (an
      email click, a sign-up, a logged-in customer). klaviyo.js applies the store's consent rules.
   2. The cart attribute holds the latest answer and Shopify copies it onto the order's additional
      details at checkout. An attribute never touches line items.
   3. GA4 (G-13Z0TZ2YTY, property 469788598) through the gtag the Google & YouTube app already runs
      on the storefront, so it joins the visitor's existing GA session and follows its consent mode.
      Only short, non-identifying parameters are sent.

   SIZE answers come from the size guide page and the product page size drawer, which redraw on every
   change: nothing is sent until an answer has sat unchanged for 2.5 seconds. STYLE answers are a
   deliberate final screen and are sent at once. Either way the same answer is sent once per
   browser session. */
(function () {
  if (window.PulseSizeTrack) return;
  var GA_ID = 'G-13Z0TZ2YTY';
  var KIND = {
    size: { klaviyo: 'Used Size Finder', cart: 'Size finder', ga: 'size_finder_used',
            params: ['surface', 'method', 'brand', 'scale', 'status', 'pulse_size', 'market', 'product'] },
    style: { klaviyo: 'Used Style Finder', cart: 'Style finder', ga: 'style_finder_result',
             params: ['surface', 'match', 'runner_up', 'wide', 'market'] }
  };
  var timers = {}, sent = {};
  try { sent = JSON.parse(sessionStorage.getItem('pulse-size-track') || '{}') || {}; } catch (e) { sent = {}; }
  function remember() { try { sessionStorage.setItem('pulse-size-track', JSON.stringify(sent)); } catch (e) {} }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function ga(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ send_to: GA_ID }, params || {})); } catch (e) {}
  }

  function send(p, kind) {
    var k = KIND[kind], key = kind + '|' + p.summary;
    if (!k || !p.summary || sent[key]) return;
    sent[key] = 1; remember();
    try { (window.klaviyo = window.klaviyo || []).push(['track', k.klaviyo, p]); } catch (e) {}
    try {
      var attrs = {}; attrs[k.cart] = p.summary;
      fetch(root() + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) {}
    var gp = {};
    k.params.forEach(function (f) { if (p[f] !== undefined && p[f] !== '') gp[f] = String(p[f]).slice(0, 100); });
    ga(k.ga, gp);
  }

  function pulseSize(row, scale) {
    if (!row) return '';
    var us = scale === 'men' ? row.usm : row.usw;
    return (scale === 'men' ? "men's" : "women's") + ' US ' + us + ' · UK ' + row.uk + ' · EU ' + row.eu;
  }
  function context() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return { market: (window.Shopify && Shopify.country) || '', product: m ? m[1] : '' };
  }

  window.PulseSizeTrack = {
    pulseSize: pulseSize,
    context: context,
    ga: ga,
    /* size answers; payload null cancels a pending send, e.g. the brand was cleared */
    record: function (surface, payload) {
      clearTimeout(timers[surface]);
      if (!payload) return;
      timers[surface] = setTimeout(function () { send(payload, 'size'); }, 2500);
    },
    /* style finder result: sent at once */
    recordStyle: function (payload) { if (payload) send(payload, 'style'); }
  };
})();
